import { colors } from "theme/palette";

import Button from "components/Button";
import Link from "components/Link";
import Stack from "components/Stack";
import Text from "components/Text";

const BookADemoBox = () => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{
      paddingX: 2,
      paddingY: 1.5,
      borderRadius: "8px",
      backgroundColor: colors.blue40,
    }}
  >
    <Stack>
      <Text variant="text2" fontWeight={700}>
        Unlock the full power of Builders Patch
      </Text>
      <Text variant="text4">
        If you are interested in seeing the full capabilities of this platform
        please book 30 minutes to chat with our sales team.
      </Text>
    </Stack>

    <Stack direction="row" gap={2}>
      <Link external to="https://builderspatch.com/developers">
        <Button variant="outlined" sx={{ whiteSpace: "nowrap" }}>
          Learn more
        </Button>
      </Link>

      <Link external to="https://builderspatch.com/freedemo">
        <Button sx={{ whiteSpace: "nowrap" }}>Book a demo</Button>
      </Link>
    </Stack>
  </Stack>
);

export default BookADemoBox;
